<template>
  <usage-chart :raw-data="rawData" :loading="loading" />
</template>

<script setup>

import {ref, onMounted} from 'vue'
import { useStore } from 'vuex'
import UsageChart from "@/admin/components/eshops/UsageChart.vue";

const store = useStore()
const rawData = ref([])
const loading = ref(false)

onMounted(async () => {
  await loadData()
})

async function loadData() {
  loading.value = true
  const response = await store.state.api.post('/admin/eshops/global-usage-data')
  rawData.value = response.data?.usageData || []
  loading.value = false
}

</script>
